// ResetPassword.jsx
import { Form, Input, Button, message, Card, Row, Col } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLoading } from "context/loadingContext";
import ResetPassword from "functions/merchant/resetPassword";
import { bg_button, bg_shadow, bg_text } from "constant/css";

const ResetPasswordScreen = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { showLoading, hideLoading } = useLoading();
  const navigate = useNavigate();
  const onFinish = async ({ password }) => {
    showLoading();
    try {
      const response = await ResetPassword(token, password);
      if (response) {
        message.success(
          "Таны шинэ нууц үг амжилттай хадгалагдлаа.Нэвтэрч орно уу"
        );
        navigate("/merchant");
        // Optionally redirect to login page
      }
    } catch {
      message.error("Invalid or expired token.");
    } finally {
      hideLoading();
    }
  };

  return (
    <div
      className="move-area"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card
        style={{
          minWidth: "400px",
          maxWidth: "500px",
          borderRadius: 20,
          alignSelf: "center",
          margin: "auto",
          padding: "30px",
        }}
        className={`${bg_shadow}`}
      >
        {/* <HeartPulse /> */}
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
          }}
        >
          <span
            className={`${bg_text} text-4xl text-transparent font-extrabold mb-6 leading-tight`}
            style={{ fontSize: 30 }}
          >
            Мерчант нууц үг сэргээх
          </span>
        </div>
        <Form onFinish={onFinish}>
          <Row style={{ width: "100%" }}>
            <Col
              span={24}
              style={{
                justifyItems: "center",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    min: 6,
                    message: "Багадаа 6 тэмдэгт оруулна уу",
                  },
                ]}
              >
                <Input.Password
                  className="w-[200px]"
                  placeholder="Шинэ нууц үг орууна уу"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Col
              span={24}
              style={{
                justifyItems: "center",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Button
                type="primary"
                className={`${bg_button} ${bg_shadow}`}
                htmlType="submit"
              >
                Хадгалах
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPasswordScreen;
